var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-toggle-group"},[_c('Button',_vm._b({class:['toggle', _vm.buttonClass],attrs:{"action":_vm.showInfoPopup}},'Button',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4c5536","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/base/InfoPopupToggle.vue
// module id = null
// module chunks = 